import {
  LOADING,
  PLATFORM_CONFIGURATION,
  REVIEWS,
} from "../actionType/reputationManagerType";
import {
  authorizeToGoogleForRM,
  connectToGoogleForRM,
  reviewsConfiguration,
  reviewsListingUrl,
} from "../constant/Constant";
import {
  deleteAuthMethod,
  getAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";

export const connectToGoogleRM = (payload) => (dispatch) => {
  return postAuthMethod(connectToGoogleForRM, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const authorizeGoogleRM = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(`${authorizeToGoogleForRM}?code=${payload}`)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      dispatch(getPlatformConfiguration());
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getPlatformReviews = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  const params = Object.entries(payload)
    ?.filter(([key, value]) => key !== "size")
    .map(([key, value]) =>
      [
        "rating",
        "responseStatus",
        "sentiment",
        "platformName",
        "responded",
      ].includes(key)
        ? `${key}.equals=${value}`
        : `${key}=${value}`
    )
    .join("&");

  return getAuthMethod(
    `${reviewsListingUrl}?size=${payload?.size ? payload?.size : 6}&sort=reviewDate,desc&${params}`
  )
    .then((res) => {
      dispatch({
        type: REVIEWS,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const removePlatformConfiguration = () => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return deleteAuthMethod(reviewsConfiguration)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getPlatformConfiguration = () => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return getAuthMethod(reviewsConfiguration)
    .then((res) => {
      dispatch({
        type: PLATFORM_CONFIGURATION,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res.data;
    })
    .catch((err) => {
      dispatch({
        type: PLATFORM_CONFIGURATION,
        payload: null,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};
